import Moment from 'moment'
import { QNImageUtil } from '@/utils'
import { normalizeStandingList } from '@/api/wheel-battle/adapter'
import {
  childGameToSubMatch,
  computeStanding
} from '@/api/wheel-battle/child-game-sync'
import { resolveUnionMatchIcon } from '@/views/match-manage/wheel-battle/utils/team-logo'

function formatDisplayTime(dateVal) {
  if (!dateVal) {
    return ''
  }
  var m = Moment(dateVal)
  if (!m.isValid()) {
    return ''
  }
  return m.format('HH:mm')
}

function formatDisplayDate(dateVal) {
  if (!dateVal) {
    return ''
  }
  var m = Moment(dateVal)
  if (!m.isValid()) {
    return ''
  }
  var weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  return m.format('YY/M/D') + ' ' + weekMap[m.day()] + ' ' + m.format('HH:mm')
}

function extractGroupLabel(parentGame) {
  if (!parentGame || !parentGame.name) {
    return ''
  }
  var name = String(parentGame.name)
  if (name.indexOf('车轮战') !== -1) {
    return name.replace(/车轮战$/, '')
  }
  return name
}

function isChildGameInProgress(childGame, isCurrent) {
  if (!childGame) {
    return false
  }
  if (isCurrent) {
    return childGame.resultType === 0 || childGame.status === 0
  }
  return false
}

function buildConsumerMatchItem(childGame, parentGame, isCurrent) {
  var subMatch = childGameToSubMatch(childGame, {
    isCurrent: isCurrent && childGame.resultType === 0
  })
  if (!subMatch) {
    return null
  }
  var inProgress = isChildGameInProgress(childGame, isCurrent)
  var timeSource = inProgress
    ? (childGame.createdAt || parentGame.beginDate)
    : (childGame.finishedAt || childGame.createdAt || parentGame.beginDate)

  return {
    id: subMatch.id,
    label: subMatch.label,
    status: inProgress ? 'inProgress' : 'completed',
    statusLabel: inProgress ? '进行中' : '已完赛',
    homeTeam: subMatch.homeTeam,
    awayTeam: subMatch.awayTeam,
    homeScore: subMatch.homeScore,
    awayScore: subMatch.awayScore,
    timeText: formatDisplayTime(timeSource),
    fieldName: parentGame.fieldName || ''
  }
}

function buildConsumerMatchList(apiDetail, parentGame) {
  var list = []
  var current = apiDetail.currentChildGame
  if (current) {
    var currentItem = buildConsumerMatchItem(current, parentGame, true)
    if (currentItem) {
      list.push(currentItem)
    }
  }
  var completed = (apiDetail.childGames || []).slice()
  completed.sort(function (a, b) {
    return (b.sequenceNo || 0) - (a.sequenceNo || 0)
  })
  completed.forEach(function (childGame) {
    if (current && String(childGame.id) === String(current.id)) {
      return
    }
    var item = buildConsumerMatchItem(childGame, parentGame, false)
    if (item) {
      list.push(item)
    }
  })
  return list
}

function resolveStanding(apiDetail) {
  if (apiDetail.standing && apiDetail.standing.length) {
    return normalizeStandingList(apiDetail.standing)
  }
  var childGames = (apiDetail.childGames || []).slice()
  var current = apiDetail.currentChildGame
  if (current && (current.resultType === 1 || current.resultType === 2 || current.status === 1)) {
    childGames.push(current)
  }
  return computeStanding(apiDetail.rotationOrder, childGames)
}

function resolveParentGameStateName(parentGame) {
  if (!parentGame) {
    return ''
  }
  if (parentGame.stateName) {
    return String(parentGame.stateName)
  }
  var state = Number(parentGame.state)
  if (state === 1) {
    return '进行中'
  }
  if (state === 2) {
    return '已结束'
  }
  if (state === 0) {
    return '未开始'
  }
  return ''
}

export function wheelBattleConsumerStateFromApiDetail(apiDetail, matchInfo) {
  if (!apiDetail || !apiDetail.parentGame) {
    return null
  }
  var parentGame = apiDetail.parentGame
  var stageRule = apiDetail.stageRule || {}
  var ruleType = stageRule.rotationType || stageRule.wheelRuleType || ''
  var match = matchInfo || {}
  var unionMatchIcon = resolveUnionMatchIcon(parentGame)
  var matchIcon = match.icon
    || (unionMatchIcon ? QNImageUtil.imageView(unionMatchIcon) : '')

  return {
    parentGame: parentGame,
    matchBanner: {
      name: match.name || '',
      groupStage: match.groupStage || '',
      icon: matchIcon
    },
    header: {
      name: parentGame.name || '',
      groupLabel: extractGroupLabel(parentGame),
      state: parentGame.state,
      parentStateName: resolveParentGameStateName(parentGame),
      wheelRuleType: ruleType,
      ruleTag: ruleType ? String(ruleType).replace(/制度$/, '') : '限时',
      beginDateText: formatDisplayDate(parentGame.beginDate),
      fieldName: parentGame.fieldName || ''
    },
    waitingTeams: (apiDetail.waitingTeams || []).slice(0, 2),
    matchList: buildConsumerMatchList(apiDetail, parentGame),
    standing: resolveStanding(apiDetail)
  }
}
